import { clear, Console } from 'console';
import React, { useState, useEffect, useCallback } from 'react';
import { focusFirstElement, updateElementFocus } from '../../../misc/helpers';
import './InctroductionalModal.css';

const IntroductionalModal = (props: any) => {

	const [initLoad, setInitLoad] = useState(true);
	const [currentPlayingAudio, setCurrentPlayingAudio] = useState(0);
	const introductionAudios: any[] = [
		new Audio('assets/audio/00-Introduction/BC-Intro-Part-1.mp3'),
		new Audio('assets/audio/00-Introduction/BC-Intro-Part-2.mp3'),
		new Audio('assets/audio/00-Introduction/BC-Intro-Part-3.mp3'),
		new Audio('assets/audio/00-Introduction/BC-Intro-Part-4-alt-2.mp3'),
		new Audio('assets/audio/00-Introduction/BC-Intro-Part-5.mp3')
	];

	const [currentAudio, setCurrentAudio] = useState(introductionAudios[currentPlayingAudio]);
	const [showCloseBtn, setShowCloseBtn] = useState(true);

	const handleKey = useCallback((e: any) => {
		if (e.keyCode === 9) {//focus trap to prevent tabbing throught the element behind the popup
			let focusableParent = document.querySelector('#introduction-modal');
			if (!focusableParent) return;
			let focusable = focusableParent.querySelectorAll('.tap-to-start, .close-btn, .tabbed-header');
			updateElementFocus(e, focusable);
		}
	}, []);

	useEffect(() => {
		if (initLoad) {
			window.document.addEventListener('keydown', handleKey);
			focusFirstElement(handleKey);
			return;
		}
		currentAudio.play();
		currentAudio.addEventListener('ended', () => {
			currentAudio.pause();
			if (currentPlayingAudio < introductionAudios.length - 1) {
				setCurrentPlayingAudio(currentPlayingAudio + 1);
				setCurrentAudio(introductionAudios[currentPlayingAudio + 1]);
			}
			else {
				setShowCloseBtn(true);
			}
		});
	}, [currentAudio, initLoad]);


	const onChangeValueKeyboard = (e: any) => {
		if (e.keyCode == 32 || e.keyCode == 13) { //32 - spacebar, 36 - enter
			setInitLoad(false);
		}
	};

	const closeIntroductionReview = (e: any) => {
		currentAudio.pause();
		window.document.removeEventListener('keydown', handleKey);
		props.closeIntroductionReview();
	};

	return (
		props && props.displayed ?
			<div id="introduction-modal" className="introduction-backfround modal-disable-select" >
				{initLoad ?
					<div className="first-container" style={{
						background: 'url(assets/startscreen/bg.png)',
						backgroundRepeat: 'no-repeat',
						backgroundSize: '100% 100%'
					}}
					>
						<div className="tap-to-start start-btn-background"
							tabIndex={0}
							onKeyDown={onChangeValueKeyboard}>
							<button className="start-btn"
								onClick={() => {
									setInitLoad(false);
								}}>Tap to start</button>
						</div></div>
					:
					<div className="introduction-container" style={{
						background: 'url(assets/startscreen/bg.png)',
						backgroundRepeat: 'no-repeat',
						backgroundSize: '100% 100%'
					}}>
						<div className="introduction-block">
							{showCloseBtn && <img className="close-btn" src="./assets/startscreen/close.png" alt="close" role="button"
								tabIndex={0}
								onKeyDown={(e: any) => {
									if (e.keyCode == 32 || e.keyCode == 13) { //32 - spacebar, 36 - enter
										closeIntroductionReview(e);
									}
								}}
								onClick={(e) => {
									closeIntroductionReview(e);
								}} />}
							<img className="logo-btn" src="./assets/icon/icon2.png" alt="logo" />
							<h1 className="tabbed-header" tabIndex={0} role="paragraph">First Care Responder Bleeding Control Application</h1>
							<img className="logo-btn" src="./assets/icon/icon2.png" alt="VA" />

							<br />

							<div className="tabbed-header" tabIndex={0}>
								<p>
									Welcome to the First Care Responder Bleeding Control Application.
									This is a game-based learning module designed to train VA personnel in proper bystander
									bleeding control methods until Emergency Medical Services arrive.
								</p>

								<p>
									You will go through practice scenarios that are designed to teach proper bleeding control techniques,
									such as applying direct pressure to a bleeding wound and correct placement of a tourniquet.
									Feedback will be provided so that you may learn areas where improvement can be made.

								</p>
								<p>
									After the practice scenarios are completed, you will be given additional scenarios to check your learning.
								</p>
								<p>
									It will take approximately 50 minutes to successfully complete the entire training.
								</p>
								<p>
									You must complete all the scenarios in one session. If you leave the game, you will have to start from the beginning again.
								</p>
							</div>
						</div>
					</div>
				}
			</div>
			: <div></div>
	);
};

export default IntroductionalModal;
